import { useEffect, useState } from 'react';

type Partner = {
    image: string;
    name: string;
    link: string;
};

const partners: Partner[] = [
    { image: '/simulation Actisse.png', name: 'Actisse', link: 'https://actisse.fr' },
    { image: '/Bannière SEGEC pour site Armor.png', name: 'OWA Print Solutions', link: 'https://www.owa-solutions.fr/fr' },
    { image: '/simulation Dyalog.png', name: 'Dyalog', link: 'https://www.mydyalog.com' },
];

export default function PartnersCarousel() {
    const [index, setIndex] = useState(0);
    const [paused, setPaused] = useState(false);

    useEffect(() => {
        if (paused) return;
        const interval = setInterval(() => {
            setIndex((i) => (i + 1) % partners.length);
        }, 2800);
        return () => clearInterval(interval);
    }, [paused]);

    const partner = partners[index];

    return (
        <div onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
            <a
                href={partner.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visiter le site de ${partner.name}`}
                onFocus={() => setPaused(true)}
                onBlur={() => setPaused(false)}
                className="group relative block overflow-hidden border border-segec-green/20 h-64 sm:h-80"
            >
                <div className="absolute inset-0 bg-segec-green-deep">
                    {partners.map((p, i) => (
                        <div
                            key={p.image}
                            className="absolute inset-0"
                            style={{ opacity: i === index ? 1 : 0, transition: 'opacity 900ms ease-in-out' }}
                        >
                            {/* Fond flouté — comble les bandes sans montrer de couleur plate */}
                            <img
                                src={encodeURI(p.image)}
                                alt=""
                                aria-hidden="true"
                                className="absolute inset-0 w-full h-full object-cover scale-110 blur-2xl brightness-50"
                            />
                            {/* Bannière nette, entière, sans recadrage */}
                            <img
                                src={encodeURI(p.image)}
                                alt={p.name}
                                className="absolute inset-0 w-full h-full object-contain brightness-95 transition-transform duration-700 group-hover:scale-[1.02]"
                            />
                        </div>
                    ))}
                </div>
            </a>

            <div className="flex items-center justify-center gap-2 mt-5">
                {partners.map((p, i) => (
                    <button
                        key={p.name}
                        onClick={() => setIndex(i)}
                        aria-label={`Afficher ${p.name}`}
                        aria-current={i === index}
                        className={`h-2.5 rounded-full transition-all duration-300 ${i === index ? 'w-7 bg-segec-green' : 'w-2.5 bg-gray-200 hover:bg-gray-300'}`}
                    />
                ))}
            </div>
        </div>
    );
}
